import Switch from '@mui/material/Switch';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import classNames from 'classnames';
import { ReactElement } from 'react';

import useRole from '~/store/user/hooks/useRole';
import extractDateFromString from '~/utils/date/extractDateFromString';
import { IResource } from '~/services/api/resource/types';
import getFileTypeIcon from '~/ui/pages/Resources/helpers/getFileTypeIcon';

import ResourceType from '~/ui/pages/Resources/models/ResourceType';
import styles from './Table.module.scss';

interface IProps {
  item: IResource;
  onUpdateResource: (item: IResource) => Promise<void>;
  onArchiveResource: (id: number) => Promise<void>;
  setResource: (item: IResource) => void;
  downloadFile: (item: IResource) => void;
  openFile: (item: IResource) => void;
}

const ResourceItem = ({
  item,
  onUpdateResource,
  onArchiveResource,
  setResource,
  downloadFile,
  openFile,
}: IProps): ReactElement => {
  const { isSuperAdmin } = useRole();

  const canOpen = ![ResourceType.Excel, ResourceType.Document, ResourceType.Presentation].includes(
    item.type,
  );

  return (
    <>
      <TableRow key={item.id}>
        <TableCell colSpan={4}>
          <div className={styles.firstCell}>
            {getFileTypeIcon(item.type)} <span>{item.name}</span>
          </div>
        </TableCell>
        <TableCell>{extractDateFromString(item.modifiedOn)}</TableCell>
        {isSuperAdmin && (
          <TableCell>
            <Switch
              checked={item.isVisible}
              name="isVisible"
              color="primary"
              onChange={() => {
                onUpdateResource({ ...item, isVisible: !item.isVisible });
              }}
            />
          </TableCell>
        )}
        <TableCell colSpan={3} className={styles.actionsCell} align="right">
          {canOpen && (
            <IconButton
              onClick={() => {
                openFile(item);
              }}
              size="large"
            >
              <div className={classNames(styles.iconBlack, styles.viewOpenIcon)} />
            </IconButton>
          )}

          <IconButton
            onClick={() => {
              downloadFile(item);
            }}
            size="large"
          >
            <div className={classNames(styles.iconBlack, styles.downloadIcon)} />
          </IconButton>
          {isSuperAdmin && (
            <>
              <IconButton
                onClick={() => {
                  setResource(item);
                }}
                size="large"
              >
                <div className={classNames(styles.iconBlack, styles.editIcon)} />
              </IconButton>
              <IconButton
                onClick={() => {
                  onArchiveResource(item.id);
                }}
                size="large"
              >
                <div className={classNames(styles.iconBlack, styles.trashIcon)} />
              </IconButton>
            </>
          )}
        </TableCell>
      </TableRow>
    </>
  );
};

export default ResourceItem;
